import React, { useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { RouteComponentProps } from "react-router-dom";
import { ExperimentState, HotelsModuleProps, CoreStaysCheckout } from "redmond";
import { useUserContext, isCorpTenant } from "@capone/common";

import { useStaysCheckoutProps } from "@capone/portal";
import config from "../../../utils/config";
import { colors as caponeColors } from "../../../utils/capone/colors";
import { colors as corpColors } from "../../../utils/capone-corporate/colors";
import App from "../../../../../../cap1-modules/hotels-module/src/App";

interface IHotelsModuleProps extends RouteComponentProps {
  language: string;
  experiments?: ExperimentState;
  crossSellLoaded: boolean;
  recentlyViewedLoaded: boolean;
  annualTravelCreditLoaded: boolean;
  core?: CoreStaysCheckout;
}

const HotelsModule = (props: IHotelsModuleProps) => {
  const { language, experiments, core, ...routerProps } = props;
  const theme = useTheme();

  const { sessionInfo, policies, logo } = useUserContext(config.TENANT);
  const { history } = routerProps;

  const moduleProps: HotelsModuleProps = useMemo(
    () => ({
      colors: isCorpTenant(config.TENANT) ? corpColors : caponeColors,
      experiments,
      language,
      theme,
      baseHistory: history,
      clientAssets: {
        sessionInfo,
        logo: <img src={logo?.src} alt={logo?.alt} />,
        policies,
      },
      isAgentPortal: config.ptIsAgentPortal,
      core,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <App {...moduleProps} />;
};

export const LegacyStaysBooking = (
  props: React.ComponentProps<typeof HotelsModule>
) => {
  const checkoutProps = useStaysCheckoutProps();

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <HotelsModule {...props} core={checkoutProps} />;
};
